const TaxTypes = [
  { label: "VAT", id: "VAT" },
  { label: "GST", id: "GST" },
  { label: "Sales tax", id: "SALES_TAX" },
  { label: "No indirect tax", id: "NO_INDIRECT_TAX" },
  { label: "Reverse charge", id: "REVERSE_CHARGE" },
];

export default TaxTypes;
